import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  oneDailyQuizHistory: {},
  oneQualDailyQuizHistory: {},
});

const reducer = function oneDailyQuizHistoryReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.ONE_DAILY_QUIZ_HISTORY:
      return state.set('oneDailyQuizHistory', action.oneDailyQuizHistory);

    case t.SET_ONE_QUAL_DAILY_QUIZ_HISTORY:
      return state.set(
        'oneQualDailyQuizHistory',
        action.oneQualDailyQuizHistory,
      );

    case t.RESET_ONE_QUAL_DAILY_QUIZ_HISTORY:
      return state.set('oneQualDailyQuizHistory', {});

    default:
      return state;
  }
};

export default reducer;
